const handleScroll = (position) => {
    document.body.scrollTo({
        top: position - 80,
        left: 0,
        behavior: 'smooth'
    })
}

export default handleScroll;